const _ = require('lodash');

const buildDataStructure = (serviceProviders, permissions) => {

	const data = [];

	serviceProviders.forEach(sp => {
  	
    	data.push({
      	id: sp.id,
      	name: sp.name,
        categories: permissions.filter(p => {
        	
          	if(!p.category) {
            
              p.category = 'General';
            }

          	return p.serviceProviderId === sp.id;
        })
      });
  });
	  
  data.forEach(item => {
  
  	const arr = _.groupBy(item.categories, i => i.category);
    
    const newCategories = [];
    
    for(const prop in arr) {
    
        if (arr.hasOwnProperty(prop)) {
            
          newCategories.push({
                name: prop,
                catId: _.uniqueId('cat_'),
                data: arr[prop]
            });   
        } 
    }
    
    item.categories = newCategories;
    
  });
      
	return data;
};

export {
    buildDataStructure
};


// WEBPACK FOOTER //
// ./src/services/permissions/index.js